import styled from 'styled-components';

export const InvestorProfileCardStyles = styled.div`
	padding: 0.5rem;
	background: ${({ theme }) => theme.v3.colors.gray[0]};

	.investor-name,
	.pob {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: block;
		min-width: 0;
		flex: 1;
	}

	.pob {
		max-width: 100%;
		text-align: right;
	}
`;
